import scrollLock from 'scroll-lock';
import { getKeyboardFocusableElements } from '../utils';

export default class Menu {
	constructor() {
		this.el = document.querySelector('[data-main-menu]');

		if (!this.el) {
			return;
		}

		this.hamburgerButton = this.el.querySelector('[data-menu-toggle]');
		this.hamburgerButton?.addEventListener('click', (e) => {
			this.isOpen ? this.close() : this.open();
		});

		const keyboardFocusableElements = getKeyboardFocusableElements(this.el).filter((el) => {
			return !el.classList.contains('c-main-menu__logo');
		});

		const firstFocusableEl = keyboardFocusableElements[0];
		const lastFocusableEl = keyboardFocusableElements[keyboardFocusableElements.length - 1];

		window.addEventListener('keydown', (e) => {
			if (window.innerWidth < 768 && this.isOpen) {
				if (e.key === 'Escape') {
					this.close();
				}

				if (e.key === 'Tab' || e.key === 9) {
					if (e.shiftKey) {
						if (document.activeElement === firstFocusableEl) {
							lastFocusableEl.focus();
							e.preventDefault();
						}
					} else {
						if (document.activeElement === lastFocusableEl) {
							firstFocusableEl.focus();
							e.preventDefault();
						}
					}
				}
			}
		});
	}

	get isOpen() {
		return this.el.classList.contains('is-open');
	}

	open() {
		window.scrollTo(0, 0);
		scrollLock.disablePageScroll();
		this.hamburgerButton.ariaExpanded = 'true';
		this.hamburgerButton.ariaLabel = 'Sluit hoofdmenu';
		this.el.classList.add('is-open');
	}

	close() {
		scrollLock.enablePageScroll();
		this.hamburgerButton.ariaExpanded = 'false';
		this.hamburgerButton.ariaLabel = 'Open hoofdmenu';
		this.el.classList.remove('is-open');
	}
}
